var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 557.631,
    height: 796.559,
    viewBox: "0 0 557.631 796.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_310",
    "data-name": "Grupo 310",
    transform: "translate(78.807 -77.601) rotate(30)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8451",
    "data-name": "Caminho 8451",
    d: "M40.5,81,0,0H81Z",
    transform: "translate(14.066 175.258) rotate(-100)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 4.5,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8452",
    "data-name": "Caminho 8452",
    d: "M48.923,97.846,0,0H97.846Z",
    transform: "translate(79.587 149.596) rotate(-92.308)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 5.385,
    opacity: 0.169
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8453",
    "data-name": "Caminho 8453",
    d: "M57.346,114.693,0,0H114.693Z",
    transform: "matrix(0.094, -0.996, 0.996, 0.094, 142.619, 135.786)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 6.269,
    opacity: 0.238
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8454",
    "data-name": "Caminho 8454",
    d: "M65.769,131.539,0,0H131.539Z",
    transform: "translate(201.262 132.654) rotate(-76.923)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 7.154,
    opacity: 0.308
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8455",
    "data-name": "Caminho 8455",
    d: "M74.192,148.384,0,0H148.384Z",
    transform: "translate(253.889 138.742) rotate(-69.231)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 8.038,
    opacity: 0.377
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8456",
    "data-name": "Caminho 8456",
    d: "M82.616,165.232,0,0H165.231Z",
    transform: "translate(299.206 152.349) rotate(-61.538)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 8.923,
    opacity: 0.446
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8457",
    "data-name": "Caminho 8457",
    d: "M91.039,182.078,0,0H182.078Z",
    transform: "translate(336.244 171.622) rotate(-53.846)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 9.808,
    opacity: 0.515
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8458",
    "data-name": "Caminho 8458",
    d: "M99.461,198.922,0,0H198.922Z",
    transform: "matrix(0.693, -0.721, 0.721, 0.693, 364.414, 194.608)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 10.692,
    opacity: 0.585
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8459",
    "data-name": "Caminho 8459",
    d: "M107.884,215.77,0,0H215.77Z",
    transform: "matrix(0.783, -0.622, 0.622, 0.783, 383.5, 219.271)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 11.577,
    opacity: 0.654
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8460",
    "data-name": "Caminho 8460",
    d: "M116.307,232.615,0,0H232.615Z",
    transform: "translate(393.654 243.657) rotate(-30.769)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 12.462,
    opacity: 0.723
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8461",
    "data-name": "Caminho 8461",
    d: "M124.731,249.461,0,0H249.461Z",
    transform: "translate(395.401 265.841) rotate(-23.077)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 13.346,
    opacity: 0.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8462",
    "data-name": "Caminho 8462",
    d: "M133.153,266.308,0,0H266.308Z",
    transform: "translate(389.603 284.085) rotate(-15.385)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 14.231,
    opacity: 0.862
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8463",
    "data-name": "Caminho 8463",
    d: "M141.577,283.154,0,0H283.154Z",
    transform: "matrix(0.991, -0.134, 0.134, 0.991, 377.425, 296.843)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 15.115,
    opacity: 0.931
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8464",
    "data-name": "Caminho 8464",
    d: "M150,300,0,0H300Z",
    transform: "translate(360.303 302.804)",
    fill: "none",
    stroke: "#bde8ff",
    strokeWidth: 16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeta);
export default __webpack_public_path__ + "static/media/seta.d49f7a0685a7c8512556d7667601db1b.svg";
export { ForwardRef as ReactComponent };